import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Lock, AlertCircle, Calculator, Clock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

interface CashRegisterClosedOverlayProps {
  locationName?: string;
  onOpenCashRegister?: () => void;
}

export const CashRegisterClosedOverlay: React.FC<CashRegisterClosedOverlayProps> = ({
  locationName,
  onOpenCashRegister
}) => {
  const navigate = useNavigate();

  const handleOpenCashRegister = () => {
    if (onOpenCashRegister) {
      onOpenCashRegister();
    } else {
      // Navigate to cash register page
      navigate('/cash-register');
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="flex justify-center mb-4">
            <div className="p-3 bg-red-100 rounded-full">
              <Lock className="w-8 h-8 text-red-600" />
            </div>
          </div>
          <CardTitle className="text-xl text-gray-900">
            Caja Registradora Cerrada
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <Alert className="border-orange-200 bg-orange-50">
            <AlertCircle className="w-4 h-4 text-orange-600" />
            <AlertDescription className="text-orange-800">
              <strong>No se pueden realizar ventas.</strong>
              <br />
              La caja registradora de {locationName || 'esta ubicación'} está cerrada.
            </AlertDescription>
          </Alert>

          <div className="bg-gray-50 p-4 rounded-lg">
            <h4 className="font-medium text-gray-900 mb-2 flex items-center">
              <Calculator className="w-4 h-4 mr-2" />
              Para comenzar a vender necesitas:
            </h4>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• Abrir la caja registradora</li>
              <li>• Registrar el monto inicial</li>
              <li>• Confirmar el turno actual</li>
            </ul>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
            <div className="flex items-center text-blue-800 mb-2">
              <Clock className="w-4 h-4 mr-2" />
              <span className="font-medium">Estado actual</span>
            </div>
            <p className="text-sm text-blue-700">
              Sin caja abierta para el día de hoy
            </p>
          </div>

          <div className="flex flex-col space-y-2">
            <Button
              onClick={handleOpenCashRegister}
              className="w-full bg-macartur-primary hover:bg-macartur-primary/90"
            >
              <Calculator className="w-4 h-4 mr-2" />
              Abrir Caja Registradora
            </Button>
            
          </div>

          <div className="text-xs text-gray-500 text-center">
            <p>
              💡 <strong>Tip:</strong> Una vez que abras la caja, podrás realizar ventas normalmente.
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};